export default "__VITE_ASSET__BECbb3TG__"